import { Firebase } from '../../firebase/config';
import { ensureUserDoc } from '../../firebase/collections';
import {
  sendEmailVerification,
  signInWithPopup,
} from '../../firebase/auth';
import { logSignUp } from '../../firebase/analytics';
import {
  validateRequired,
  validateEmail,
  validatePassword,
  validatePhone,
} from '../../utils/validation';

export function handleSocialSignUp(providerName, provider, { setLoading, setErrors, addToast, history, t }) {
  setLoading(true);
  setErrors({});
  signInWithPopup(provider)
    .then((result) => ensureUserDoc(result.user))
    .then(() => {
      logSignUp(providerName);
      addToast(t('auth.accountCreated'), 'success');
      history.push('/');
    })
    .catch((error) => {
      setLoading(false);
      setErrors({
        form: t('auth.somethingWentWrong'),
      });
    });
}

export function handleGuestContinue({ addToast, history, t }) {
  addToast(t('auth.guestToast'), 'info');
  history.push('/');
}

export function handleSubmit(e, { name, email, phone, password, termsAccepted, emailSubscribed, setLoading, setErrors, addToast, history, t }) {
  e.preventDefault();
  const err = {};
  if (validateRequired(name, t('auth.fullName')))
    err.name = t('auth.fullNameRequired');
  const eErr = validateEmail(email);
  if (eErr) err.email = eErr;
  const pErr = validatePhone(phone);
  if (pErr) err.phone = pErr;
  const pwErr = validatePassword(password);
  if (pwErr) err.password = pwErr;
  if (!termsAccepted) err.terms = t('auth.mustAcceptTerms');
  setErrors(err);
  if (Object.keys(err).length > 0) return;

  setLoading(true);
  
  // Подробное логирование перед отправкой запроса регистрации
  console.log('[SIGNUP] Attempting to create user with:', {
    email: email,
    name: name,
    phone: phone,
    timestamp: new Date().toISOString()
  });

  // Проверка существования email перед созданием аккаунта
  Firebase.auth()
    .fetchSignInMethodsForEmail(email)
    .then((signInMethods) => {
      if (signInMethods && signInMethods.length > 0) {
        // Email уже зарегистрирован
        setLoading(false);
        setErrors({ email: 'Этот email уже зарегистрирован. Пожалуйста, войдите или используйте другой email.' });
        console.log('[SIGNUP] Email already exists:', email);
        return Promise.reject({ code: 'auth/email-already-in-use' });
      }
      // Email свободен, продолжаем регистрацию
      console.log('[SIGNUP] Email is available, proceeding with registration:', email);
      return Firebase.auth().createUserWithEmailAndPassword(email, password);
    })
    .then((result) => {
      return result.user.updateProfile({ displayName: name }).then(() =>
        ensureUserDoc(result.user, {
          name: name.trim(),
          phone: String(phone).trim(),
          emailSubscribed: emailSubscribed ?? false,
        })
      );
    })
    .then(() => sendEmailVerification())
    .then(() => {
      logSignUp('email');
      addToast(t('auth.accountCreatedVerifyEmail'), 'success');
      history.push('/login');
    })
    .catch((error) => {
      setLoading(false);
      
      // Подробное логирование ошибки
      console.error('[SIGNUP ERROR] Full error object:', error);
      console.error('[SIGNUP ERROR] Error code:', error.code);
      console.error('[SIGNUP ERROR] Error message:', error.message);
      console.error('[SIGNUP ERROR] Error customData:', error.customData);
      console.error('[SIGNUP ERROR] Error stack:', error.stack);
      
      // Обработка ошибок Firebase Auth
      let errorMessage = 'Произошла ошибка. Пожалуйста, попробуйте снова.';
      
      switch (error.code) {
        case 'auth/email-already-in-use':
          // Email уже существует (наша проверка)
          errorMessage = 'Этот email уже зарегистрирован. Пожалуйста, войдите или используйте другой email.';
          setErrors({ email: errorMessage });
          return;
        case 'auth/user-not-found':
          // Это не ошибка - email свободен, но мы не должны сюда попасть
          console.log('[SIGNUP] Email not found (should not reach here):', email);
          return;
        case 'auth/invalid-email':
          errorMessage = 'Некорректный формат email.';
          setErrors({ email: errorMessage });
          return;
        case 'auth/weak-password':
          errorMessage = 'Пароль слишком слабый. Используйте минимум 6 символов.';
          setErrors({ password: errorMessage });
          return;
        case 'auth/too-many-requests':
          errorMessage = 'Слишком много попыток. Пожалуйста, подождите немного и попробуйте снова.';
          setErrors({ form: errorMessage });
          return;
        case 'auth/network-request-failed':
          errorMessage = 'Ошибка сети. Проверьте подключение к интернету.';
          setErrors({ form: errorMessage });
          return;
        default:
          // Общая ошибка
          setErrors({ form: errorMessage });
          return;
      }
    });
}
